import React, { useContext } from 'react'
import { notify } from '../../../../utils/index_tagging_tool'
import { saveCustomRule } from '../../../api_methods'

export function DeSaveOperation({ context }) {
  const { operationsPossible, checkedRules, dimension, setLoading } =
    useContext(context)

  const saveRule = async (rule) => {
    const data = {}
    data['headers'] = {
      save: false,
      dim_pk: dimension,
    }

    saveCustomRule(rule.id, data)
  }

  const saveRules = async (e) => {
    e.preventDefault()
    setLoading(true)
    const ruleList = JSON.parse(
      JSON.stringify(checkedRules.filter((r) => !r.report_id))
    )
    await Promise.all(
      ruleList.map(async (rule) => {
        // Scorro i selezionati e cancello tutto
        if (rule.id !== -1) {
          try {
            await saveRule(rule)
          } catch (e) {
            notify(e.message, 'error')
          }
        }
      })
    )
    window.location.reload()
  }

  return (
    <>
      {operationsPossible.includes('Desalva') && (
        <div className={'operationsDiv'} onClick={saveRules}>
          DeSalva
        </div>
      )}
    </>
  )
}
